<template>
  <div class="cat-tiposplantilla-cedula">
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" class="form-control" v-model="idDelModelo" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de plantilla</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} los tipos de plantilla</option>
        <option v-for="tipoPlantilla in tiposPlantilla" :value="tipoPlantilla.TipoPlantillaId">{{tipoPlantilla.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        tiposPlantilla: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
      
      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }      
      this.$store.dispatch("A_SINOJ_Catalogos_establecer009TiposPlantilla", parametros);      
    },
    methods: {
      cargaCatalogoDeJurisdicciones: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        this.parametros.conAreasDeJurisdiccion = true;

        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

        axios.post(api.conexion + api.SINOJ.catalogos.C009TiposPlantilla, this.parametros, headerPeticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.tiposPlantilla = respuesta.data.TiposPlantilla;              
              if(this.valorDefinido != undefined && this.valorDefinido != null)
              {                
                let tipoPlantillaObj =  this.obtenerTipoPlantillaObj(this.valorDefinido);                 
                this.$emit("inicializacionPlantilla",tipoPlantillaObj);
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        let tipoPlantillaObj = this.obtenerTipoPlantillaObj(evento.target.value);
        this.$store.dispatch("A_SINOJ_Catalogos_establecer009TiposPlantilla", parametros);
        this.$emit("valorParaElPadre", evento,tipoPlantillaObj);
      },
      obtenerTipoPlantillaObj: function(tipoPlantillaId) {        
        let id = parseInt(tipoPlantillaId);
        let tipoPlantilla = null;
        this.tiposPlantilla.filter(tpBD => tpBD.TipoPlantillaId == id).forEach(tp => {tipoPlantilla = tp});         
        return tipoPlantilla;
      }
    },
    created() {      
      this.cargaCatalogoDeJurisdicciones();
    }
  }
</script>
<style>
.cat-tiposplantilla-cedula .form-control {
  background-color: white !important;
    color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/Catalogos/C009TiposPlantilla.vue